import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { array, object, string } from "yup"
import { Dayjs } from "dayjs"

type EventValue<DateType> = DateType | null
export type RangeValue<DateType> = [EventValue<DateType>, EventValue<DateType>] | null

export interface FiltersForm {
  status?: string
  start_date?: {
    operator: string
    values?: RangeValue<Dayjs | null> | undefined
  }
}

export function useFiltersForm(defaultValues?: FiltersForm) {
  const schema = object({
    status: string().nullable(),
    start_date: object({
      operator: string().nullable(),
      values: array().of(string().nullable()).nullable(),
    }),
  }).required()

  return useForm<FiltersForm>({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
